import { h } from "preact";

import classname from "../../../foundation/utils/classname";
import ProgressIndicatorIcon from "../ProgressIndicatorIcon";

import styles from "./ProgressInformationView.module.css";

interface Props {
    class?: string;
    progress: number;
    title?: string;
    description?: string;
}

function ProgressInformationView({
    class: cssClass,
    progress,
    title,
    description
}: Props) {
    return (
        <div class={classname(styles.progressInformationView, cssClass)}>
            <div class={styles.progressIconContainer}>
                <ProgressIndicatorIcon progress={progress}/>
            </div>
            <div class={styles.progressTextContainer}>
                <span class={classname(styles.progressTitle, "body-1 medium")}>{title}</span>
                <span class={classname(styles.progressDescription, "body-1")}>{description}</span>
            </div>
        </div>
    );
}

export default ProgressInformationView;
export {
    Props as ProgressInformationViewProps
};
